<div
  class="select"
  [class.action]="this.options.length > 0"
  (click)="this.options.length > 0 && onSelectClicked($event)"
>
  <span class="selected">
    <ng-content></ng-content>
  </span>
  <svg
    *ngIf="this.options.length > 0"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [ngClass]="{ caret: true, 'caret-rotate': isMenuOpen }"
  >
    <g id="ArrowDown">
      <path
        id="Vector"
        d="M3.93892 5.06831C3.69038 4.81977 3.28742 4.81977 3.03888 5.06831C2.79035 5.31684 2.79035 5.7198 3.03888 5.96834L7.43167 10.3611C7.5654 10.4949 7.78222 10.4949 7.91595 10.3611L12.3087 5.96834C12.5573 5.7198 12.5573 5.31684 12.3087 5.06831C12.0602 4.81977 11.6572 4.81977 11.4087 5.06831L7.67381 8.8032L3.93892 5.06831Z"
        fill="black"
        fill-opacity="0.35"
      />
    </g>
  </svg>
</div>
<ul
  *ngIf="this.options.length"
  [ngClass]="{ 'menu-open': isMenuOpen }"
  outsideClick
  (outsideClick)="isMenuOpen = false"
>
  <li
    *ngFor="let option of options"
    [ngClass]="{
      active: isMulti
        ? selectedOptions.includes(option)
        : selectedOption === option,
    }"
    (click)="onSelectedOptionChanged(option)"
  >
    {{ option }}
  </li>
</ul>
